import { create } from "zustand";

type ToastVariant = "info" | "success" | "warning" | "error" | "alert";
type ToastAlignment = "top-right" | "bottom-right";

interface ToastState {
  toastMessage: string;
  toastHeader: string;
  toastVariant: ToastVariant;
  isActionToast: boolean;
  alignment: ToastAlignment;
  showToast: boolean;
  setToast: (params: {
    message: string;
    header: string;
    variant: ToastVariant;
    isActionToast?: boolean;
    alignment?: ToastAlignment;
  }) => void;
  hideToast: () => void;
}

const useToastStore = create<ToastState>((set) => ({
  toastMessage: "",
  toastHeader: "",
  toastVariant: "info",
  isActionToast: false,
  alignment: "top-right",
  showToast: false,
  setToast: ({
    message,
    header,
    variant,
    isActionToast = true,
    alignment = "top-right",
  }) =>
    set({
      toastMessage: message,
      toastHeader: header,
      toastVariant: variant,
      isActionToast,
      alignment,
      showToast: true,
    }),
  hideToast: () => set({ showToast: false }),
}));

export { useToastStore };
